import { defineComponent as qt, watchEffect as ne, ref as p, toRef as ue, computed as C, onMounted as Jt, getCurrentInstance as Qt, watch as de, provide as Zt, h as a, Fragment as en, nextTick as ce } from "vue";
import { isSafari as tn } from "./ghl-ui.es918.js";
import { useRtl as nn } from "./ghl-ui.es884.js";
import { inputInjectionKey as on } from "./ghl-ui.es1043.js";
import { useCursor as rn, isEmptyInputValue as L } from "./ghl-ui.es1044.js";
import fe from "./ghl-ui.es1045.js";
import an, { safariStyle as ln } from "./ghl-ui.es1046.js";
import { warnOnce as sn } from "./ghl-ui.es886.js";
import un from "./ghl-ui.es887.js";
import ye from "./ghl-ui.es888.js";
import dn from "./ghl-ui.es927.js";
import cn from "./ghl-ui.es938.js";
import fn from "./ghl-ui.es727.js";
import hn from "./ghl-ui.es920.js";
import he from "./ghl-ui.es721.js";
import { createKey as oe } from "./ghl-ui.es739.js";
import { getMargin as vn } from "./ghl-ui.es770.js";
import { useThemeClass as pn } from "./ghl-ui.es889.js";
import { resolveWrappedSlot as j, resolveSlot as re } from "./ghl-ui.es892.js";
import gn from "./ghl-ui.es1011.js";
import mn from "./ghl-ui.es767.js";
import yn from "./ghl-ui.es1047.js";
import { on as ve, off as pe } from "./ghl-ui.es725.js";
import { call as g } from "./ghl-ui.es925.js";
import ge from "./ghl-ui.es1048.js";
import bn from "./ghl-ui.es1049.js";
import me from "./ghl-ui.es894.js";
import xn from "./ghl-ui.es1050.js";
import wn from "./ghl-ui.es1051.js";
const Cn = Object.assign(Object.assign({}, ye.props), {
  bordered: {
    type: Boolean,
    default: void 0
  },
  type: {
    type: String,
    default: "text"
  },
  placeholder: [Array, String],
  defaultValue: {
    type: [String, Array],
    default: null
  },
  value: [String, Array],
  disabled: {
    type: Boolean,
    default: void 0
  },
  size: String,
  rows: {
    type: [Number, String],
    default: 3
  },
  round: Boolean,
  minlength: [String, Number],
  maxlength: [String, Number],
  clearable: Boolean,
  autosize: {
    type: [Boolean, Object],
    default: !1
  },
  pair: Boolean,
  separator: String,
  readonly: {
    type: [String, Boolean],
    default: !1
  },
  passivelyActivated: Boolean,
  showPasswordOn: String,
  stateful: {
    type: Boolean,
    default: !0
  },
  autofocus: Boolean,
  inputProps: Object,
  resizable: {
    type: Boolean,
    default: !0
  },
  showCount: Boolean,
  loading: {
    type: Boolean,
    default: void 0
  },
  allowInput: Function,
  renderCount: Function,
  onMousedown: Function,
  onKeydown: Function,
  onKeyup: [Function, Array],
  onInput: [Function, Array],
  onFocus: [Function, Array],
  onBlur: [Function, Array],
  onClick: [Function, Array],
  onChange: [Function, Array],
  onClear: [Function, Array],
  countGraphemes: Function,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  /** private */
  textDecoration: [String, Array],
  attrSize: {
    type: Number,
    default: 20
  },
  onInputBlur: [Function, Array],
  onInputFocus: [Function, Array],
  onDeactivate: [Function, Array],
  onActivate: [Function, Array],
  onWrapperFocus: [Function, Array],
  onWrapperBlur: [Function, Array],
  internalDeactivateOnEnter: Boolean,
  internalForceFocus: Boolean,
  internalLoadingBeforeSuffix: {
    type: Boolean,
    default: !0
  },
  /** deprecated */
  showPasswordToggle: Boolean
}), Qn = qt({
  name: "Input",
  props: Cn,
  setup(n) {
    process.env.NODE_ENV !== "production" && ne(() => {
      n.showPasswordToggle && sn("input", '`show-password-toggle` is deprecated, please use `showPasswordOn="click"` instead');
    });
    const { mergedClsPrefixRef: y, mergedBorderedRef: r, inlineThemeDisabled: P, mergedRtlRef: G } = un(n), b = ye("Input", "-input", an, yn, n, y);
    tn && dn("-input-safari", ln, y);
    const v = p(null), f = p(null), c = p(null), i = p(null), l = p(null), h = p(null), m = p(null), M = rn(m), S = p(null), { localeRef: be } = cn("Input"), W = p(n.defaultValue), xe = ue(n, "value"), x = fn(xe, W), T = hn(n), { mergedSizeRef: X, mergedDisabledRef: _, mergedStatusRef: we } = T, B = p(!1), I = p(!1), w = p(!1), $ = p(!1);
    let Y = null;
    const q = C(() => {
      const { placeholder: e, pair: t } = n;
      return t ? Array.isArray(e) ? e : e === void 0 ? ["", ""] : [e, e] : e === void 0 ? [be.value.placeholder] : [e];
    }), Ce = C(() => {
      const { value: e } = w, { value: t } = x, { value: o } = q;
      return !e && (L(t) || Array.isArray(t) && L(t[0])) && o[0];
    }), Se = C(() => {
      const { value: e } = w, { value: t } = x, { value: o } = q;
      return !e && o[1] && (L(t) || Array.isArray(t) && L(t[1]));
    }), J = he(() => n.internalForceFocus || B.value), Ae = he(() => {
      if (_.value || n.readonly || !n.clearable || !J.value && !I.value)
        return !1;
      const { value: e } = x, { value: t } = J;
      return n.pair ? !!(Array.isArray(e) && (e[0] || e[1])) && (I.value || t) : !!e && (I.value || t);
    }), Q = C(() => {
      const { showPasswordOn: e } = n;
      if (e)
        return e;
      if (n.showPasswordToggle)
        return "click";
    }), V = p(!1), Fe = C(() => {
      const { textDecoration: e } = n;
      return e ? Array.isArray(e) ? e.map((t) => ({
        textDecoration: t
      })) : [
        {
          textDecoration: e
        }
      ] : ["", ""];
    }), ae = p(void 0), Re = () => {
      var e, t;
      if (n.type === "textarea") {
        const { autosize: o } = n;
        if (o && (ae.value = (t = (e = S.value) === null || e === void 0 ? void 0 : e.$el) === null || t === void 0 ? void 0 : t.offsetWidth), !f.value || typeof o == "boolean")
          return;
        const { paddingTop: u, paddingBottom: d, lineHeight: s } = window.getComputedStyle(f.value), A = Number(u.slice(0, -2)), F = Number(d.slice(0, -2)), R = Number(s.slice(0, -2)), { value: z } = c;
        if (!z)
          return;
        if (o.minRows) {
          const D = Math.max(o.minRows, 1), te = `${A + F + R * D}px`;
          z.style.minHeight = te;
        }
        if (o.maxRows) {
          const D = `${A + F + R * o.maxRows}px`;
          z.style.maxHeight = D;
        }
      }
    }, _e = C(() => {
      const { maxlength: e } = n;
      return e === void 0 ? void 0 : Number(e);
    });
    Jt(() => {
      const { value: e } = x;
      Array.isArray(e) || ee(e);
    });
    const Be = Qt().proxy;
    function O(e) {
      const { onUpdateValue: t, "onUpdate:value": o, onInput: u } = n, { nTriggerFormInput: d } = T;
      t && g(t, e), o && g(o, e), u && g(u, e), W.value = e, d();
    }
    function N(e) {
      const { onChange: t } = n, { nTriggerFormChange: o } = T;
      t && g(t, e), W.value = e, o();
    }
    function Ee(e) {
      const { onBlur: t } = n, { nTriggerFormBlur: o } = T;
      t && g(t, e), o();
    }
    function Pe(e) {
      const { onFocus: t } = n, { nTriggerFormFocus: o } = T;
      t && g(t, e), o();
    }
    function Te(e) {
      const { onClear: t } = n;
      t && g(t, e);
    }
    function Ie(e) {
      const { onInputBlur: t } = n;
      t && g(t, e);
    }
    function $e(e) {
      const { onInputFocus: t } = n;
      t && g(t, e);
    }
    function Ve() {
      const { onDeactivate: e } = n;
      e && g(e);
    }
    function ze() {
      const { onActivate: e } = n;
      e && g(e);
    }
    function De(e) {
      const { onClick: t } = n;
      t && g(t, e);
    }
    function Me(e) {
      const { onWrapperFocus: t } = n;
      t && g(t, e);
    }
    function We(e) {
      const { onWrapperBlur: t } = n;
      t && g(t, e);
    }
    function Oe() {
      w.value = !0;
    }
    function Ne(e) {
      w.value = !1, e.target === h.value ? k(e, 1) : k(e, 0);
    }
    function k(e, t = 0, o = "input") {
      const u = e.target.value;
      if (ee(u), e instanceof InputEvent && !e.isComposing && (w.value = !1), n.type === "textarea") {
        const { value: s } = S;
        s && s.syncUnifiedContainer();
      }
      if (Y = u, w.value)
        return;
      M.recordCursor();
      const d = ke(u);
      if (d)
        if (!n.pair)
          o === "input" ? O(u) : N(u);
        else {
          let { value: s } = x;
          Array.isArray(s) ? s = [s[0], s[1]] : s = ["", ""], s[t] = u, o === "input" ? O(s) : N(s);
        }
      Be.$forceUpdate(), d || ce(M.restoreCursor);
    }
    function ke(e) {
      const { countGraphemes: t, maxlength: o, minlength: u } = n;
      if (t) {
        let s;
        if (o !== void 0 && (s === void 0 && (s = t(e)), s > Number(o)) || u !== void 0 && (s === void 0 && (s = t(e)), s < Number(o)))
          return !1;
      }
      const { allowInput: d } = n;
      return typeof d == "function" ? d(e) : !0;
    }
    function He(e) {
      Ie(e), e.relatedTarget === v.value && Ve(), e.relatedTarget !== null && (e.relatedTarget === l.value || e.relatedTarget === h.value || e.relatedTarget === f.value) || ($.value = !1), H(e, "blur"), m.value = null;
    }
    function Ke(e, t) {
      $e(e), B.value = !0, $.value = !0, ze(), H(e, "focus"), t === 0 ? m.value = l.value : t === 1 ? m.value = h.value : t === 2 && (m.value = f.value);
    }
    function Ue(e) {
      n.passivelyActivated && (We(e), H(e, "blur"));
    }
    function Le(e) {
      n.passivelyActivated && (B.value = !0, Me(e), H(e, "focus"));
    }
    function H(e, t) {
      e.relatedTarget !== null && (e.relatedTarget === l.value || e.relatedTarget === h.value || e.relatedTarget === f.value || e.relatedTarget === v.value) || (t === "focus" ? (Pe(e), B.value = !0) : t === "blur" && (Ee(e), B.value = !1));
    }
    function je(e, t) {
      k(e, t, "change");
    }
    function Ge(e) {
      De(e);
    }
    function Xe(e) {
      Te(e), n.pair ? (O(["", ""]), N(["", ""])) : (O(""), N(""));
    }
    function Ye(e) {
      const { onMousedown: t } = n;
      t && t(e);
      const { tagName: o } = e.target;
      if (o !== "INPUT" && o !== "TEXTAREA") {
        if (n.resizable) {
          const { value: u } = v;
          if (u) {
            const { left: d, top: s, width: A, height: F } = u.getBoundingClientRect(), R = 14;
            if (d + A - R < e.clientX && e.clientX < d + A && s + F - R < e.clientY && e.clientY < s + F)
              return;
          }
        }
        e.preventDefault(), B.value || le();
      }
    }
    function qe() {
      var e;
      I.value = !0, n.type === "textarea" && ((e = S.value) === null || e === void 0 || e.handleMouseEnterWrapper());
    }
    function Je() {
      var e;
      I.value = !1, n.type === "textarea" && ((e = S.value) === null || e === void 0 || e.handleMouseLeaveWrapper());
    }
    function Qe() {
      _.value || Q.value === "click" && (V.value = !V.value);
    }
    function Ze(e) {
      if (_.value)
        return;
      e.preventDefault();
      const t = (u) => {
        u.preventDefault(), pe("mouseup", document, t);
      };
      if (ve("mouseup", document, t), Q.value !== "mousedown")
        return;
      V.value = !0;
      const o = () => {
        V.value = !1, pe("mouseup", document, o);
      };
      ve("mouseup", document, o);
    }
    function et(e) {
      n.onKeyup && g(n.onKeyup, e);
    }
    function tt(e) {
      switch (n.onKeydown && g(n.onKeydown, e), e.key) {
        case "Escape":
          Z();
          break;
        case "Enter":
          nt(e);
          break;
      }
    }
    function nt(e) {
      var t, o;
      if (n.passivelyActivated) {
        const { value: u } = $;
        if (u) {
          n.internalDeactivateOnEnter && Z();
          return;
        }
        e.preventDefault(), n.type === "textarea" ? (t = f.value) === null || t === void 0 || t.focus() : (o = l.value) === null || o === void 0 || o.focus();
      }
    }
    function Z() {
      n.passivelyActivated && ($.value = !1, ce(() => {
        var e;
        (e = v.value) === null || e === void 0 || e.focus();
      }));
    }
    function le() {
      var e, t, o;
      _.value || (n.passivelyActivated ? (e = v.value) === null || e === void 0 || e.focus() : ((t = f.value) === null || t === void 0 || t.focus(), (o = l.value) === null || o === void 0 || o.focus()));
    }
    function ot() {
      var e;
      !((e = v.value) === null || e === void 0) && e.contains(document.activeElement) && document.activeElement.blur();
    }
    function rt() {
      var e, t;
      (e = f.value) === null || e === void 0 || e.select(), (t = l.value) === null || t === void 0 || t.select();
    }
    function at() {
      _.value || (f.value ? f.value.focus() : l.value && l.value.focus());
    }
    function lt() {
      const { value: e } = v;
      e != null && e.contains(document.activeElement) && e !== document.activeElement && Z();
    }
    function it(e) {
      if (n.type === "textarea") {
        const { value: t } = f;
        t == null || t.scrollTo(e);
      } else {
        const { value: t } = l;
        t == null || t.scrollTo(e);
      }
    }
    function ee(e) {
      const { type: t, pair: o, autosize: u } = n;
      if (!o && u)
        if (t === "textarea") {
          const { value: d } = c;
          d && (d.textContent = (e ?? "") + `\r
`);
        } else {
          const { value: d } = i;
          d && (e ? d.textContent = e : d.innerHTML = "&nbsp;");
        }
    }
    function st() {
      Re();
    }
    const ie = p({
      top: "0"
    });
    function ut(e) {
      var t;
      const { scrollTop: o } = e.target;
      ie.value.top = `${-o}px`, (t = S.value) === null || t === void 0 || t.syncUnifiedContainer();
    }
    let K = null;
    ne(() => {
      const { autosize: e, type: t } = n;
      e && t === "textarea" ? K = de(x, (o) => {
        !Array.isArray(o) && o !== Y && ee(o);
      }) : K == null || K();
    });
    let U = null;
    ne(() => {
      n.type === "textarea" ? U = de(x, (e) => {
        var t;
        !Array.isArray(e) && e !== Y && ((t = S.value) === null || t === void 0 || t.syncUnifiedContainer());
      }) : U == null || U();
    }), Zt(on, {
      mergedValueRef: x,
      maxlengthRef: _e,
      mergedClsPrefixRef: y,
      countGraphemesRef: ue(n, "countGraphemes")
    });
    const dt = {
      wrapperElRef: v,
      inputElRef: l,
      textareaElRef: f,
      isCompositing: w,
      focus: le,
      blur: ot,
      select: rt,
      deactivate: lt,
      activate: at,
      scrollTo: it
    }, ct = nn("Input", G, y), se = C(() => {
      const { value: e } = X, { common: { cubicBezierEaseInOut: t }, self: { color: o, borderRadius: u, textColor: d, caretColor: s, caretColorError: A, caretColorWarning: F, textDecorationColor: R, border: z, borderDisabled: D, borderHover: te, borderFocus: ft, placeholderColor: ht, placeholderColorDisabled: vt, lineHeightTextarea: pt, colorDisabled: gt, colorFocus: mt, textColorDisabled: yt, boxShadowFocus: bt, iconSize: xt, colorFocusWarning: wt, boxShadowFocusWarning: Ct, borderWarning: St, borderFocusWarning: At, borderHoverWarning: Ft, colorFocusError: Rt, boxShadowFocusError: _t, borderError: Bt, borderFocusError: Et, borderHoverError: Pt, clearSize: Tt, clearColor: It, clearColorHover: $t, clearColorPressed: Vt, iconColor: zt, iconColorDisabled: Dt, suffixTextColor: Mt, countTextColor: Wt, countTextColorDisabled: Ot, iconColorHover: Nt, iconColorPressed: kt, loadingColor: Ht, loadingColorError: Kt, loadingColorWarning: Ut, [oe("padding", e)]: Lt, [oe("fontSize", e)]: jt, [oe("height", e)]: Gt } } = b.value, { left: Xt, right: Yt } = vn(Lt);
      return {
        "--n-bezier": t,
        "--n-count-text-color": Wt,
        "--n-count-text-color-disabled": Ot,
        "--n-color": o,
        "--n-font-size": jt,
        "--n-border-radius": u,
        "--n-height": Gt,
        "--n-padding-left": Xt,
        "--n-padding-right": Yt,
        "--n-text-color": d,
        "--n-caret-color": s,
        "--n-text-decoration-color": R,
        "--n-border": z,
        "--n-border-disabled": D,
        "--n-border-hover": te,
        "--n-border-focus": ft,
        "--n-placeholder-color": ht,
        "--n-placeholder-color-disabled": vt,
        "--n-icon-size": xt,
        "--n-line-height-textarea": pt,
        "--n-color-disabled": gt,
        "--n-color-focus": mt,
        "--n-text-color-disabled": yt,
        "--n-box-shadow-focus": bt,
        "--n-loading-color": Ht,
        // form warning
        "--n-caret-color-warning": F,
        "--n-color-focus-warning": wt,
        "--n-box-shadow-focus-warning": Ct,
        "--n-border-warning": St,
        "--n-border-focus-warning": At,
        "--n-border-hover-warning": Ft,
        "--n-loading-color-warning": Ut,
        // form error
        "--n-caret-color-error": A,
        "--n-color-focus-error": Rt,
        "--n-box-shadow-focus-error": _t,
        "--n-border-error": Bt,
        "--n-border-focus-error": Et,
        "--n-border-hover-error": Pt,
        "--n-loading-color-error": Kt,
        // clear-button
        "--n-clear-color": It,
        "--n-clear-size": Tt,
        "--n-clear-color-hover": $t,
        "--n-clear-color-pressed": Vt,
        "--n-icon-color": zt,
        "--n-icon-color-hover": Nt,
        "--n-icon-color-pressed": kt,
        "--n-icon-color-disabled": Dt,
        "--n-suffix-text-color": Mt
      };
    }), E = P ? pn("input", C(() => {
      const { value: e } = X;
      return e[0];
    }), se, n) : void 0;
    return Object.assign(Object.assign({}, dt), {
      // DOM ref
      wrapperElRef: v,
      inputElRef: l,
      inputMirrorElRef: i,
      inputEl2Ref: h,
      textareaElRef: f,
      textareaMirrorElRef: c,
      textareaScrollbarInstRef: S,
      // value
      rtlEnabled: ct,
      uncontrolledValue: W,
      mergedValue: x,
      passwordVisible: V,
      mergedPlaceholder: q,
      showPlaceholder1: Ce,
      showPlaceholder2: Se,
      mergedFocus: J,
      isComposing: w,
      activated: $,
      showClearButton: Ae,
      mergedSize: X,
      mergedDisabled: _,
      textDecorationStyle: Fe,
      mergedClsPrefix: y,
      mergedBordered: r,
      mergedShowPasswordOn: Q,
      placeholderStyle: ie,
      mergedStatus: we,
      textAreaScrollContainerWidth: ae,
      // methods
      handleTextAreaScroll: ut,
      handleCompositionStart: Oe,
      handleCompositionEnd: Ne,
      handleInput: k,
      handleInputBlur: He,
      handleInputFocus: Ke,
      handleWrapperBlur: Ue,
      handleWrapperFocus: Le,
      handleMouseEnter: qe,
      handleMouseLeave: Je,
      handleMouseDown: Ye,
      handleChange: je,
      handleClick: Ge,
      handleClear: Xe,
      handlePasswordToggleClick: Qe,
      handlePasswordToggleMousedown: Ze,
      handleWrapperKeydown: tt,
      handleWrapperKeyup: et,
      handleTextAreaMirrorResize: st,
      getTextareaScrollContainer: () => f.value,
      mergedTheme: b,
      cssVars: P ? void 0 : se,
      themeClass: E == null ? void 0 : E.themeClass,
      onRender: E == null ? void 0 : E.onRender
    });
  },
  render() {
    var n, y;
    const { mergedClsPrefix: r, mergedStatus: P, themeClass: G, type: b, countGraphemes: v, onRender: f } = this, c = this.$slots;
    return f == null || f(), a(
      "div",
      { ref: "wrapperElRef", class: [
        `${r}-input`,
        G,
        P && `${r}-input--${P}-status`,
        {
          [`${r}-input--rtl`]: this.rtlEnabled,
          [`${r}-input--disabled`]: this.mergedDisabled,
          [`${r}-input--textarea`]: b === "textarea",
          [`${r}-input--resizable`]: this.resizable && !this.autosize,
          [`${r}-input--autosize`]: this.autosize,
          [`${r}-input--round`]: this.round && b !== "textarea",
          [`${r}-input--pair`]: this.pair,
          [`${r}-input--focus`]: this.mergedFocus,
          [`${r}-input--stateful`]: this.stateful
        }
      ], style: this.cssVars, tabindex: !this.mergedDisabled && this.passivelyActivated && !this.activated ? 0 : void 0, onFocus: this.handleWrapperFocus, onBlur: this.handleWrapperBlur, onClick: this.handleClick, onMousedown: this.handleMouseDown, onMouseenter: this.handleMouseEnter, onMouseleave: this.handleMouseLeave, onCompositionstart: this.handleCompositionStart, onCompositionend: this.handleCompositionEnd, onKeyup: this.handleWrapperKeyup, onKeydown: this.handleWrapperKeydown },
      a(
        "div",
        { class: `${r}-input-wrapper` },
        j(c.prefix, (i) => i && a("div", { class: `${r}-input__prefix` }, i)),
        b === "textarea" ? a(gn, { ref: "textareaScrollbarInstRef", class: `${r}-input__textarea`, container: this.getTextareaScrollContainer, triggerDisplayManually: !0, useUnifiedContainer: !0, internalHoistYRail: !0 }, {
          default: () => {
            var i, l;
            const { textAreaScrollContainerWidth: h } = this, m = {
              width: this.autosize && h && `${h}px`
            };
            return a(
              en,
              null,
              a("textarea", Object.assign({}, this.inputProps, { ref: "textareaElRef", class: [
                `${r}-input__textarea-el`,
                (i = this.inputProps) === null || i === void 0 ? void 0 : i.class
              ], autofocus: this.autofocus, rows: Number(this.rows), placeholder: this.placeholder, value: this.mergedValue, disabled: this.mergedDisabled, maxlength: v ? void 0 : this.maxlength, minlength: v ? void 0 : this.minlength, readonly: this.readonly, tabindex: this.passivelyActivated && !this.activated ? -1 : void 0, style: [
                this.textDecorationStyle[0],
                (l = this.inputProps) === null || l === void 0 ? void 0 : l.style,
                m
              ], onBlur: this.handleInputBlur, onFocus: (M) => {
                this.handleInputFocus(M, 2);
              }, onInput: this.handleInput, onChange: this.handleChange, onScroll: this.handleTextAreaScroll })),
              this.showPlaceholder1 ? a("div", { class: `${r}-input__placeholder`, style: [
                this.placeholderStyle,
                m
              ], key: "placeholder" }, this.mergedPlaceholder[0]) : null,
              this.autosize ? a(mn, { onResize: this.handleTextAreaMirrorResize }, {
                default: () => a("div", { ref: "textareaMirrorElRef", class: `${r}-input__textarea-mirror`, key: "mirror" })
              }) : null
            );
          }
        }) : a(
          "div",
          { class: `${r}-input__input` },
          a("input", Object.assign({ type: b === "password" && this.mergedShowPasswordOn && this.passwordVisible ? "text" : b }, this.inputProps, { ref: "inputElRef", class: [
            `${r}-input__input-el`,
            (n = this.inputProps) === null || n === void 0 ? void 0 : n.class
          ], style: [
            this.textDecorationStyle[0],
            (y = this.inputProps) === null || y === void 0 ? void 0 : y.style
          ], tabindex: this.passivelyActivated && !this.activated ? -1 : void 0, placeholder: this.mergedPlaceholder[0], disabled: this.mergedDisabled, maxlength: v ? void 0 : this.maxlength, minlength: v ? void 0 : this.minlength, value: Array.isArray(this.mergedValue) ? this.mergedValue[0] : this.mergedValue, readonly: this.readonly, autofocus: this.autofocus, size: this.attrSize, onBlur: this.handleInputBlur, onFocus: (i) => {
            this.handleInputFocus(i, 0);
          }, onInput: (i) => {
            this.handleInput(i, 0);
          }, onChange: (i) => {
            this.handleChange(i, 0);
          } })),
          this.showPlaceholder1 ? a(
            "div",
            { class: `${r}-input__placeholder` },
            a("span", null, this.mergedPlaceholder[0])
          ) : null,
          this.autosize ? a("div", { class: `${r}-input__input-mirror`, key: "mirror", ref: "inputMirrorElRef" }, " ") : null
        ),
        !this.pair && j(c.suffix, (i) => i || this.clearable || this.showCount || this.mergedShowPasswordOn || this.loading !== void 0 ? a("div", { class: `${r}-input__suffix` }, [
          j(c["clear-icon-placeholder"], (l) => (this.clearable || l) && a(ge, { clsPrefix: r, show: this.showClearButton, onClear: this.handleClear }, {
            placeholder: () => l,
            icon: () => {
              var h, m;
              return (m = (h = this.$slots)["clear-icon"]) === null || m === void 0 ? void 0 : m.call(h);
            }
          })),
          this.internalLoadingBeforeSuffix ? null : i,
          this.loading !== void 0 ? a(bn, { clsPrefix: r, loading: this.loading, showArrow: !1, showClear: !1, style: this.cssVars }) : null,
          this.internalLoadingBeforeSuffix ? i : null,
          this.showCount && this.type !== "textarea" ? a(fe, null, {
            default: (l) => {
              var h;
              return (h = c.count) === null || h === void 0 ? void 0 : h.call(c, l);
            }
          }) : null,
          this.mergedShowPasswordOn && this.type === "password" ? a("div", { class: `${r}-input__eye`, onMousedown: this.handlePasswordToggleMousedown, onClick: this.handlePasswordToggleClick }, this.passwordVisible ? re(c["password-visible-icon"], () => [
            a(me, { clsPrefix: r }, { default: () => a(xn, null) })
          ]) : re(c["password-invisible-icon"], () => [
            a(me, { clsPrefix: r }, { default: () => a(wn, null) })
          ])) : null
        ]) : null)
      ),
      this.pair ? a("span", { class: `${r}-input__separator` }, re(c.separator, () => [this.separator])) : null,
      this.pair ? a(
        "div",
        { class: `${r}-input-wrapper` },
        a(
          "div",
          { class: `${r}-input__input` },
          a("input", { ref: "inputEl2Ref", type: this.type, class: `${r}-input__input-el`, tabindex: this.passivelyActivated && !this.activated ? -1 : void 0, placeholder: this.mergedPlaceholder[1], disabled: this.mergedDisabled, maxlength: v ? void 0 : this.maxlength, minlength: v ? void 0 : this.minlength, value: Array.isArray(this.mergedValue) ? this.mergedValue[1] : void 0, readonly: this.readonly, style: this.textDecorationStyle[1], onBlur: this.handleInputBlur, onFocus: (i) => {
            this.handleInputFocus(i, 1);
          }, onInput: (i) => {
            this.handleInput(i, 1);
          }, onChange: (i) => {
            this.handleChange(i, 1);
          } }),
          this.showPlaceholder2 ? a(
            "div",
            { class: `${r}-input__placeholder` },
            a("span", null, this.mergedPlaceholder[1])
          ) : null
        ),
        j(c.suffix, (i) => (this.clearable || i) && a("div", { class: `${r}-input__suffix` }, [
          this.clearable && a(ge, { clsPrefix: r, show: this.showClearButton, onClear: this.handleClear }, {
            icon: () => {
              var l;
              return (l = c["clear-icon"]) === null || l === void 0 ? void 0 : l.call(c);
            },
            placeholder: () => {
              var l;
              return (l = c["clear-icon-placeholder"]) === null || l === void 0 ? void 0 : l.call(c);
            }
          }),
          i
        ]))
      ) : null,
      this.mergedBordered ? a("div", { class: `${r}-input__border` }) : null,
      this.mergedBordered ? a("div", { class: `${r}-input__state-border` }) : null,
      this.showCount && b === "textarea" ? a(fe, null, {
        default: (i) => {
          var l;
          const { renderCount: h } = this;
          return h ? h(i) : (l = c.count) === null || l === void 0 ? void 0 : l.call(c, i);
        }
      }) : null
    );
  }
});
export {
  Qn as default,
  Cn as inputProps
};
